<template>
<v-layout row>
    <v-flex xs12 sm8 offset-sm2 lg6 offset-lg3>
      <v-card>
        <progress-bar :show="form.busy"></progress-bar>
        <form @submit.prevent="edit" @keydown="form.onKeydown($event)">
          <v-card-title primary-title>
            <h3 class="headline mb-0">{{ $t('eventcategorys.edit-form.title') }}</h3>
          </v-card-title>
          <v-card-text>

            <text-input
              :form="form"
              :label="$t('eventcategorys.create-form.description')"
              :v-errors="errors"
              :value.sync="form.description"
              counter="30"
              name="description"
              v-validate="'required|max:30'"
            ></text-input>
          </v-card-text>

          <v-card-actions>
            <submit-button :form="form" :label="$t('eventcategorys.create-form.save-button')"></submit-button>
          </v-card-actions>
        </form>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import Form from 'vform';
import axios from 'axios';

export default {
  name: 'eventCategory-edit-view',

  data: () => ({
    form: new Form({
      description: ''
    })
  }),
  created() {
    const categoryId = this.$route.params.id;
    this.form.categoryId = categoryId;
    axios.get(`/api/categorys/${categoryId}`)
      .then(response => {
        console.log("Response" + response);
        const { data, status } = response;
        const { category } = data;
        if (status === 200) {
          this.form.description = category.description ;
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  methods: {
    async edit() {
      if (await this.formHasErrors()) return

      const result = await this.form.put('/api/categorys')

      if (result.status === 200) {
        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: this.$t('eventcategorys.edit-form.stored-ok-text'),
          title: this.$t('eventcategorys.edit-form.stored-ok-title'),
          modal: true
        })
        this.$router.push({ name: 'category.show' });
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/eventCategorys/edit.vue